import React, { useState } from "react";
import "./SearchBar.css";
import { AiOutlineClose } from "react-icons/ai";
import searchIcon from "../../assets/icons/search.png";
import menuIcon from "../../assets/icons/menu.png";
import useAuthStore from "../../services/authStore";

export default function SearchBar({ onMenuClick }) {
  const [isOpen, setIsOpen] = useState(false);

  const [filters, setFilters] = useState({
    name: "",
    fromDate: "",
    toDate: "",
  });

  // ✅ global setter from store — this is what makes search "global"
  const setSearchFilters = useAuthStore((s) => s.setSearchFilters);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Top bar name input — live filters as you type
  const handleTopNameChange = (e) => {
    const updated = { ...filters, name: e.target.value };
    setFilters(updated);
    setSearchFilters(updated);
  };

  const handleSearch = () => {
    setSearchFilters(filters);
    setIsOpen(false);
  };
  const handleSearchKeyDown = (e) => {
    if (e.key !== "Enter") {
      return;
    }

    e.preventDefault();

    // Update search first
    setSearchFilters(filters);

    // Enter = next
    // Shift + Enter = previous
    window.dispatchEvent(
      new CustomEvent("global-search-enter", {
        detail: {
          direction: e.shiftKey ? -1 : 1,
        },
      }),
    );
  };

  const handleClear = () => {
    const emptyFilters = {
      name: "",
      fromDate: "",
      toDate: "",
    };

    setFilters(emptyFilters);
    setSearchFilters(emptyFilters);
  };

  return (
    <div className="search-container">
      <img
        src={menuIcon}
        alt="menu"
        className="menu-inside"
        onClick={onMenuClick}
      />
      <input
        type="text"
        className="search-input"
        placeholder="Search expense by name"
        value={filters.name}
        onChange={handleTopNameChange}
        onKeyDown={handleSearchKeyDown}
      />
      <button className="search-btn" onClick={() => setIsOpen((prev) => !prev)}>
        {isOpen ? (
          <AiOutlineClose className="close-icon" size={16} />
        ) : (
          <img src={searchIcon} alt="Search" className="search-icon" />
        )}
      </button>

      {isOpen && (
        <div className="search-popup">
          {/* NAME */}
          <div className="form-row">
            <label>Name</label>

            <input
              type="text"
              name="name"
              value={filters.name}
              onChange={handleChange}
              onKeyDown={handleSearchKeyDown}
              placeholder="Search by employee name"
            />
          </div>

          {/* CREATED DATE */}
          <div className="form-row">
            <label>Created On</label>

            <div className="date-row">
              <span>From</span>

              <input
                type="date"
                name="fromDate"
                value={filters.fromDate}
                onChange={handleChange}
              />

              <span>to</span>

              <input
                type="date"
                name="toDate"
                value={filters.toDate}
                onChange={handleChange}
              />
            </div>
          </div>

          {/* FOOTER */}
          <div className="popup-footer">
            <button type="button" className="clear-btn" onClick={handleClear}>
              Clear all filters
            </button>

            <button
              type="button"
              className="search-btn-popup"
              onClick={handleSearch}
            >
              Search
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
